// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-scams-card-fraud-cmb/form-item-scams-card-fraud-cmb.component.scss
// module id = 1028
// module chunks = 0